import { getAccessToken } from './accessTokenStore';

const getJWT = () => getAccessToken();

export const headersWithJWT = () => ({
  Authorization: getJWT(),
  'Content-Type': 'application/json',
});

// JWTs are base64url encoded. In order to be decoded, they must first be converted to
// base64. To convert, replace '-' with '+' and '_' with '/'. Finally, '=' must be added
// to the end of the string until its length is divisible by 4.
const base64urlToBase64 = (str) => {
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  base64 += '='.repeat((4 - (base64.length % 4)) % 4);

  return base64;
};

export const decodeJWT = () => {
  const jwt = getJWT();

  if (!jwt) throw new Error('JWT is missing.');

  const jwtWithoutBearer = jwt.replace(/^Bearer\s+/i, '');

  // JWTs consist of three parts, separated by periods: header.payload.signature. Here, we
  // extract the payload.
  const encodedPayload = jwtWithoutBearer.split('.')[1];

  if (!encodedPayload) throw new Error('Invalid JWT.');

  const base64Payload = base64urlToBase64(encodedPayload);
  let binaryPayload;

  try {
    binaryPayload = atob(base64Payload);
  } catch (error) {
    throw new Error('Invalid JWT.');
  }

  // Convert the binary payload to UTF-8.
  const bytes = new Uint8Array([...binaryPayload].map((c) => c.charCodeAt(0)));
  const jsonPayload = new TextDecoder().decode(bytes);

  try {
    return JSON.parse(jsonPayload);
  } catch (error) {
    throw new Error('Invalid JWT.');
  }
};
